export default "__VITE_ASSET__516e55d4__"